/**
 * @description 平台信息
 * @type {Array}
 */
export const PLAYFORM = [
  {
    label: '哔哩哔哩',
    qrcode: require('@src/business-components/modals/images/qrcode-bilibili.png'),
    link: 'https://space.bilibili.com/3493282537540091?spm_id_from=333.1007.0.0',
    linkText: '进入B站',
    linkTheme: 'light',
    clickable: true
  },
  {
    label: '公众号',
    qrcode: require('@src/business-components/modals/images/qrcode-gzh.png'),
    link: '',
    linkText: '扫码关注',
    linkTheme: 'dark',
    clickable: false
  },
  {
    label: '抖音',
    qrcode: require('@src/business-components/modals/images/qrcode-douyin.png'),
    link: 'https://www.douyin.com/user/MS4wLjABAAAA91Y1f9H4q0ImiT7d4f4KpY9SSiOLWZjjcxzB1jMpaZAdfvZgu5VcPsbWntIq6Qs3?from_tab_name=main',
    linkText: '进入抖音',
    linkTheme: 'light',
    clickable: true
  },
  {
    label: '小红书',
    qrcode: require('@src/business-components/modals/images/qrcode-xhs.png'),
    link: 'https://www.xiaohongshu.com/user/profile/67526aaf000000001d02cc5d?xsec_token=AB7tgXqhObA3WGPvojS-bbuJXbUKneJFN4ucrFOmqkNJ0=&xsec_source=pc_search',
    linkText: '进入小红书',
    linkTheme: 'light',
    clickable: true
  }
];

/**
 * @description 轮询获取是否已预约的时间限制
 * @type {Number}
 */
export const POLLING_CHECK_LOGIN_STATUS_MAX_TIME = 60000;

// 公测阶段
export const PAGE_STAGE = {
  // 下载阶段
  download: { isOpen: 1, isClose: 0 }
};

// 账户预约状态
export const RESERVED_STATE = {
  // 第一次预约
  notReserved: 1,
  // 已预约
  isReserved: 1
};

// 世界观主页链接
export const WORLD_VIEW_LINK = `https://${IS_MASTER_ENV ? '' : 'test-zt.xoyo.com/'}mechabreak.seasungames.cn/p/zt/2026/01/27/world-view/index.html`;
// 世界观详情页链接
export const WORLD_VIEW_DETAIL_LINK = `https://${
  IS_MASTER_ENV ? '' : 'test-zt.xoyo.com/'
}mechabreak.seasungames.cn/p/zt/2026/01/27/world-view/index.html#/wordView`;
